import { loadCollectionRecords, loadRecordsByEquality } from './firestoreQueryHelpers';
import { normalizeContentPackRecord, normalizeEntitlementRecord } from './contentPackAccess';

export async function loadAllContentPacks(db) {
  const records = await loadCollectionRecords(db, 'contentPacks');
  return records.map((record) => normalizeContentPackRecord(record));
}

export async function loadOrganizationOwnedContentPacks(db, organizationId = '') {
  if (!organizationId) return [];

  const records = await loadRecordsByEquality(db, {
    collectionName: 'contentPacks',
    field: 'ownerId',
    value: organizationId,
  });

  return records
    .map((record) => normalizeContentPackRecord(record))
    .filter((record) => record.ownerType === 'organization');
}

export async function loadPlatformOwnedContentPacks(db) {
  const records = await loadRecordsByEquality(db, {
    collectionName: 'contentPacks',
    field: 'ownerType',
    value: 'platform',
  });

  return records.map((record) => normalizeContentPackRecord(record));
}

export async function loadEntitlementsForOrganization(db, organizationId = '') {
  if (!organizationId) return [];

  const records = await loadRecordsByEquality(db, {
    collectionName: 'entitlements',
    field: 'organizationId',
    value: organizationId,
  });

  return records.map((record) => normalizeEntitlementRecord(record));
}

export async function loadEntitlementsForContentPack(db, contentPackId = '') {
  if (!contentPackId) return [];

  const records = await loadRecordsByEquality(db, {
    collectionName: 'entitlements',
    field: 'contentPackId',
    value: contentPackId,
  });

  return records.map((record) => normalizeEntitlementRecord(record));
}
